import { render, staticRenderFns } from "./InspectionRapportList.vue?vue&type=template&id=6af51f6a&"
import script from "./InspectionRapportList.vue?vue&type=script&lang=js&"
export * from "./InspectionRapportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports